<template>
    <div :class="['py-12 md:py-20 px-4 flex', smallSize ? 'flex-col-reverse' : 'flex-col']">
        <img
            :class="['mx-auto', { 'mb-5': !smallSize }]"
            :alt="$t('empty_search_results')"
            src="/images/mascots/cry.png"
        />

        <p :class="['mx-auto text-lg text-slate-600 text-center', { 'mb-5': smallSize }]">
            {{ $t('empty_search_results') }}
        </p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'EmptySearchResult',
    computed: {
        ...mapGetters('ui', ['screenSize']),
        smallSize() {
            return this.screenSize === 'small';
        },
    },
};
</script>
